import { makeStyles } from '@material-ui/styles';

export default makeStyles(() => ({
  container: {
    marginTop: 25,
  },
  table: {
    minWidth: 650,
    padding: 1,
  },
  tableMarginTop: {
    marginTop: 35,
  },
  title: {
    margin: 15,
  },
  totalContainer: {
    flexGrow: 1,
    justifyContent: 'center',
  },
  totalTextContainer: {
    width: 100,
    backgroundColor: '#f0f4f7',
    padding: 10,
    borderRadius: 4,
    margin: '2px 10px',
  },
  grid: {
    marginTop: 30,
  },
  textAlignCenter: {
    textAlign: 'center',
  },
  gridItem: {
    '& .MuiPaper-elevation4': {
      boxShadow: 'none',
      backgroundColor: 'transparent',
    },
  },
}));
